"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArrayOfType = exports.isUUIDv4 = exports.isUUID = exports.REGEX_UUID = exports.isArrayOrString = exports.isArray = exports.isObject = exports.isBool = exports.isNumber = exports.isNonEmptyString = exports.isString = exports.optional = exports.isTrueObject = exports.isType = exports.getInvalidKeysForTypeguard = exports.getFailedKeysForTypeguard = exports.getDebugEnabled = void 0;
var getDebugEnabled = function () {
  return (process.env.AU_SDK_DEBUG_ENABLED || process.env.REACT_APP_AU_SDK_DEBUG_ENABLED || process.env.GATSBY_AU_SDK_DEBUG_ENABLED || process.env.DEBUG_ENABLED) === 'true';
};
exports.getDebugEnabled = getDebugEnabled;
var getFailedKeysForTypeguard = function (obj, ruleSet) {
  return Object.keys(ruleSet).filter(function (key) {
    return !ruleSet[key](obj[key]);
  });
};
exports.getFailedKeysForTypeguard = getFailedKeysForTypeguard;
var getInvalidKeysForTypeguard = function (obj, ruleSet) {
  return Object.keys(obj).filter(function (key) {
    return !Object.keys(ruleSet).includes(key);
  });
};
exports.getInvalidKeysForTypeguard = getInvalidKeysForTypeguard;
var isType = function (obj, ruleSet, strict) {
  if (strict === void 0) {
    strict = false;
  }
  var debug = (0, exports.getDebugEnabled)();
  var output = [];
  if (!obj) {
    if (debug) {
      output.push('============ Failed Typeguard ==============');
      output.push('Object is null or undefined or empty');
      output.push("Rule: ".concat(String(ruleSet)));
      console.debug(output);
    }
    return false;
  }
  if (!(0, exports.isTrueObject)(obj)) {
    if (debug) {
      output.push('typecheck on non-object: ' + obj);
      console.debug(output);
    }
    return false;
  }
  var invalidKeys = (0, exports.getInvalidKeysForTypeguard)(obj, ruleSet);
  var failedKeys = (0, exports.getFailedKeysForTypeguard)(obj, ruleSet);
  var strictlyValid = strict ? invalidKeys.length > 0 : true;
  if (!failedKeys.length && strictlyValid) {
    return true;
  }
  if (debug) {
    output.push('============ Failed Typeguard ==============');
    output.push("Object: ".concat(JSON.stringify(obj)));
    if (invalidKeys.length) {
      output.push('============== Invalid Keys =================');
      output.push(JSON.stringify(invalidKeys));
    }
    if (failedKeys.length) {
      console.log(ruleSet);
      console.log(obj);
      output.push('============== Failed Keys =================');
      failedKeys.forEach(function (key) {
        output.push("Key: ".concat(key, " - Value: ").concat(JSON.stringify(obj[key]), " - Rule: ").concat(String(ruleSet[key])));
      });
    }
    console.debug(output);
  }
  return false;
};
exports.isType = isType;
var isTrueObject = function (value) {
  return (0, exports.isObject)(value) && !(0, exports.isArray)(value);
};
exports.isTrueObject = isTrueObject;
var optional = function (isValidValue) {
  return function (value) {
    return value == null ? true : isValidValue(value);
  };
};
exports.optional = optional;
var isString = function (value) {
  return typeof value === 'string';
};
exports.isString = isString;
var isNonEmptyString = function (value) {
  return !!value && typeof value === 'string';
};
exports.isNonEmptyString = isNonEmptyString;
var isNumber = function (value) {
  return typeof value === 'number';
};
exports.isNumber = isNumber;
var isBool = function (value) {
  return typeof value === 'boolean';
};
exports.isBool = isBool;
var isObject = function (value) {
  return typeof value === 'object';
};
exports.isObject = isObject;
var isArray = function (value) {
  return Array.isArray(value);
};
exports.isArray = isArray;
var isArrayOrString = function (value) {
  return (0, exports.isArray)(value) || (0, exports.isString)(value);
};
exports.isArrayOrString = isArrayOrString;
exports.REGEX_UUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
var isUUID = function (uuid) {
  return (0, exports.isNonEmptyString)(uuid) && exports.REGEX_UUID.test(uuid);
};
exports.isUUID = isUUID;
var isUUIDv4 = function (uuid) {
  return (0, exports.isUUID)(uuid) && parseInt(uuid.substr(14, 1), 16) === 4;
};
exports.isUUIDv4 = isUUIDv4;
var isArrayOfType = function (values, typeguard) {
  return (0, exports.isArray)(values) && values.every(typeguard);
};
exports.isArrayOfType = isArrayOfType;